var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"relative h-full px-4 sm:px-6 lg:px-8"},[_c('div',{staticClass:"relative h-full mx-auto"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }